export type ApiObject = Record<string, unknown>

const COLLECTION_KEYS = ['items', 'categories', 'products', 'availability', 'data', 'result']
const NESTED_KEYS = ['data', 'result']

export const isApiObject = (value: unknown): value is ApiObject => Boolean(value) && typeof value === 'object' && !Array.isArray(value)

export const extractCollection = <T>(payload: unknown): T[] => {
  if (typeof payload === 'string') {
    try {
      const parsedPayload = JSON.parse(payload) as unknown
      return extractCollection<T>(parsedPayload)
    } catch {
      return []
    }
  }

  if (Array.isArray(payload)) {
    return payload.filter(isApiObject) as T[]
  }

  if (!isApiObject(payload)) {
    return []
  }

  for (const key of COLLECTION_KEYS) {
    const candidate = payload[key]
    if (Array.isArray(candidate)) {
      return candidate.filter(isApiObject) as T[]
    }
  }

  for (const key of NESTED_KEYS) {
    const candidate = payload[key]
    const nestedResult = extractCollection<T>(candidate)

    if (nestedResult.length > 0) {
      return nestedResult
    }
  }

  return []
}
